import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const ScrollToTop = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
    document.documentElement.scrollTo({ top: 0, left: 0, behavior: 'instant' })
    document.body.scrollTo({ top: 0, left: 0, behavior: 'instant' })

    const timer = setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
      document.documentElement.scrollTo({ top: 0, left: 0, behavior: 'instant' })
      document.body.scrollTo({ top: 0, left: 0, behavior: 'instant' })
    }, 20)

    return () => clearTimeout(timer)
  }, [pathname])

  return null
}

export default ScrollToTop
